(function () {
  'use strict';

  /*
   * Initialize Swiper for a recommendations section.
   */
  function initSwiper(container) {
    if (!container || container.dataset.swiperInit === 'true') return;

    var retry = 0;
    var swiperEl = container.querySelector('.ymal-swiper');

    if (!swiperEl) return;

    var perView = parseInt(
      swiperEl.dataset.slidesPerView || '5',
      10
    );

    function tryInit() {
      if (typeof Swiper === 'undefined') {
        if (retry++ > 20) return;

        setTimeout(tryInit, 100);
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,

        navigation: {
          prevEl: container.querySelector('.ymal-btn--prev'),
          nextEl: container.querySelector('.ymal-btn--next')
        },

        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 0
          },

          750: {
            slidesPerView: 3,
            spaceBetween: 0
          },

          1000: {
            slidesPerView: perView,
            spaceBetween: 0
          }
        }
      });

      container.dataset.swiperInit = 'true';

      /*
       * Re-initialize Product Card functionality.
       */
      if (
        window.ProductCard &&
        typeof window.ProductCard.init === 'function'
      ) {
        window.ProductCard.init();
      }

      /*
       * IMPORTANT:
       * Quick View cards are injected dynamically, so notify
       * quick-view.js that new triggers are available.
       */
      document.dispatchEvent(
        new CustomEvent('ornix:quick-view:init', {
          detail: {
            container: container
          }
        })
      );
    }

    tryInit();
  }


  /*
   * Load Shopify product recommendations.
   */
  function fetchRecommendations(placeholder) {
    var sectionId = placeholder.dataset.sectionId;
    var productId = placeholder.dataset.productId;
    var limit = parseInt(
      placeholder.dataset.limit,
      10
    ) || 8;

    var url =
      '/recommendations/products' +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=related';

    fetch(url, {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(
            'Recommendations request failed'
          );
        }

        return res.text();
      })

      .then(function (html) {
        var temp = document.createElement('div');

        temp.innerHTML = html;

        var fetched = temp.querySelector(
          '.ymal-section:not(.ymal-section--placeholder)'
        );

        if (
          fetched &&
          fetched.querySelector('.swiper-slide')
        ) {
          placeholder.insertAdjacentHTML(
            'afterend',
            fetched.outerHTML
          );

          var newSection =
            placeholder.nextElementSibling;

          placeholder.remove();

          if (newSection) {
            initSwiper(newSection);
          }
        } else {
          placeholder.style.display = 'none';
        }
      })

      .catch(function (error) {
        console.error(
          '[Recommendations]',
          error
        );

        placeholder.style.display = 'none';
      });
  }


  /*
   * Observe recommendation placeholder.
   */
  function observeAndLoad(placeholder) {
    if (
      !('IntersectionObserver' in window)
    ) {
      fetchRecommendations(placeholder);
      return;
    }

    var observer =
      new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) {
                return;
              }

              observer.unobserve(
                entry.target
              );

              fetchRecommendations(
                entry.target
              );
            }
          );
        },
        {
          rootMargin: '120px'
        }
      );

    observer.observe(placeholder);
  }


  /*
   * Initialize already-rendered sections.
   */
  document
    .querySelectorAll('.ymal-section')
    .forEach(function (section) {
      if (
        !section.classList.contains(
          'ymal-section--placeholder'
        )
      ) {
        initSwiper(section);
      }
    });


  /*
   * Initialize lazy-loaded recommendation sections.
   */
  document
    .querySelectorAll(
      '.ymal-section--placeholder'
    )
    .forEach(function (placeholder) {
      observeAndLoad(placeholder);
    });

})();